import { render, staticRenderFns } from "./category.vue?vue&type=template&id=44a864ec"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkLogin: require('D:/private/personal-finance/src/components/Common/LinkLogin.vue').default,AdminGuard: require('D:/private/personal-finance/src/components/Common/AdminGuard.vue').default})
